const Section = ({ children }) => (
  <section className='bg-white container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20'>
    {children}
  </section>
);

export default Section;
